import { jsxs, jsx } from 'react/jsx-runtime';

var Discover = function Discover(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === undefined ? '40' : _ref$size;
  return jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cogs-v10 cogs-graphic cogs-graphic--discover",
    children: [jsx("title", {
      children: "Discover product logo"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.5669 1.9106C25.5517 1.76221 25.4917 1.62199 25.3949 1.50849C25.2981 1.395 25.1691 1.31358 25.025 1.27503C24.8809 1.23647 24.7284 1.24258 24.5878 1.29256C24.4472 1.34254 24.325 1.43402 24.2374 1.55491L15.8899 12.8797L1.88855 14.4589C1.74486 14.476 1.60958 14.5358 1.50017 14.6306C1.39076 14.7253 1.31224 14.8507 1.27473 14.9904C1.23723 15.1302 1.24247 15.2779 1.28978 15.4146C1.33709 15.5512 1.4243 15.6706 1.54015 15.7572L12.8749 24.1148L14.4438 38.1121C14.4609 38.2558 14.5206 38.391 14.6153 38.5003C14.7099 38.6096 14.8352 38.688 14.975 38.7254C15.1147 38.7628 15.2625 38.7575 15.3992 38.71C15.536 38.6626 15.6554 38.5754 15.7421 38.4595L24.1101 27.1207L38.1115 25.5416C38.2551 25.5244 38.3904 25.4646 38.4998 25.3699C38.6092 25.2751 38.6878 25.1498 38.7253 25.01C38.7628 24.8703 38.7575 24.7225 38.7102 24.5859C38.6629 24.4492 38.5757 24.3299 38.4599 24.2433L27.1251 15.8856L25.5669 1.9106Z",
      fill: "url(#paint0_linear_2861_43292)"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.5669 1.9106C25.5517 1.76221 25.4917 1.62199 25.3949 1.50849C25.2981 1.395 25.1691 1.31358 25.025 1.27503C24.8809 1.23647 24.7284 1.24258 24.5878 1.29256C24.4472 1.34254 24.325 1.43402 24.2374 1.55491L15.8899 12.8797L1.88855 14.4589C1.74486 14.476 1.60958 14.5358 1.50017 14.6306C1.39076 14.7253 1.31224 14.8507 1.27473 14.9904C1.23723 15.1302 1.24247 15.2779 1.28978 15.4146C1.33709 15.5512 1.4243 15.6706 1.54015 15.7572L12.8749 24.1148L14.4438 38.1121C14.4609 38.2558 14.5206 38.391 14.6153 38.5003C14.7099 38.6096 14.8352 38.688 14.975 38.7254C15.1147 38.7628 15.2625 38.7575 15.3992 38.71C15.536 38.6626 15.6554 38.5754 15.7421 38.4595L24.1101 27.1207L38.1115 25.5416C38.2551 25.5244 38.3904 25.4646 38.4998 25.3699C38.6092 25.2751 38.6878 25.1498 38.7253 25.01C38.7628 24.8703 38.7575 24.7225 38.7102 24.5859C38.6629 24.4492 38.5757 24.3299 38.4599 24.2433L27.1251 15.8856L25.5669 1.9106Z",
      fill: "url(#paint1_linear_2861_43292)"
    }), jsx("path", {
      d: "M23.025 10.5989L23.8115 17.6452C23.8193 17.7089 23.8399 17.7703 23.872 17.8259C23.904 17.8814 23.9469 17.93 23.9981 17.9686L29.703 22.1837C29.7793 22.2402 29.8368 22.3183 29.868 22.408C29.8993 22.4976 29.9028 22.5946 29.8782 22.6863C29.8536 22.778 29.802 22.8602 29.73 22.9223C29.658 22.9843 29.5691 23.0233 29.4748 23.0341L22.4235 23.8364C22.3598 23.8443 22.2983 23.8649 22.2427 23.897C22.1872 23.9291 22.1386 23.972 22.0999 24.0232L17.8903 29.7329C17.8337 29.8092 17.7555 29.8668 17.6658 29.8981C17.5761 29.9294 17.4791 29.9331 17.3874 29.9085C17.2957 29.884 17.2135 29.8324 17.1515 29.7605C17.0895 29.6886 17.0506 29.5997 17.0399 29.5054L16.2534 22.459C16.2455 22.3954 16.225 22.3339 16.1929 22.2784C16.1608 22.2228 16.1179 22.1743 16.0667 22.1357L10.3619 17.9206C10.2856 17.8641 10.2281 17.786 10.1968 17.6963C10.1656 17.6067 10.162 17.5097 10.1866 17.418C10.2113 17.3262 10.2629 17.244 10.3349 17.182C10.4068 17.12 10.4957 17.081 10.5901 17.0702L17.6414 16.2679C17.7051 16.26 17.7665 16.2394 17.8221 16.2073C17.8777 16.1752 17.9263 16.1323 17.9649 16.081L22.1746 10.3714C22.2312 10.295 22.3094 10.2375 22.399 10.2062C22.4887 10.1748 22.5857 10.1712 22.6774 10.1958C22.7692 10.2203 22.8514 10.2719 22.9134 10.3438C22.9753 10.4157 23.0142 10.5045 23.025 10.5989Z",
      fill: "#DB57ED"
    }), jsx("path", {
      d: "M23.025 10.5989L23.8115 17.6452C23.8193 17.7089 23.8399 17.7703 23.872 17.8259C23.904 17.8814 23.9469 17.93 23.9981 17.9686L29.703 22.1837C29.7793 22.2402 29.8368 22.3183 29.868 22.408C29.8993 22.4976 29.9028 22.5946 29.8782 22.6863C29.8536 22.778 29.802 22.8602 29.73 22.9223C29.658 22.9843 29.5691 23.0233 29.4748 23.0341L22.4235 23.8364C22.3598 23.8443 22.2983 23.8649 22.2427 23.897C22.1872 23.9291 22.1386 23.972 22.0999 24.0232L17.8903 29.7329C17.8337 29.8092 17.7555 29.8668 17.6658 29.8981C17.5761 29.9294 17.4791 29.9331 17.3874 29.9085C17.2957 29.884 17.2135 29.8324 17.1515 29.7605C17.0895 29.6886 17.0506 29.5997 17.0399 29.5054L16.2534 22.459C16.2455 22.3954 16.225 22.3339 16.1929 22.2784C16.1608 22.2228 16.1179 22.1743 16.0667 22.1357L10.3619 17.9206C10.2856 17.8641 10.2281 17.786 10.1968 17.6963C10.1656 17.6067 10.162 17.5097 10.1866 17.418C10.2113 17.3262 10.2629 17.244 10.3349 17.182C10.4068 17.12 10.4957 17.081 10.5901 17.0702L17.6414 16.2679C17.7051 16.26 17.7665 16.2394 17.8221 16.2073C17.8777 16.1752 17.9263 16.1323 17.9649 16.081L22.1746 10.3714C22.2312 10.295 22.3094 10.2375 22.399 10.2062C22.4887 10.1748 22.5857 10.1712 22.6774 10.1958C22.7692 10.2203 22.8514 10.2719 22.9134 10.3438C22.9753 10.4157 23.0142 10.5045 23.025 10.5989Z",
      fill: "url(#paint2_radial_2861_43292)"
    }), jsx("path", {
      d: "M25.4132 1.51338C25.5099 1.62688 25.5699 1.7671 25.5852 1.91549L27.1251 15.8856L20 20.0002L25.025 1.27502C25.1691 1.31358 25.3164 1.39989 25.4132 1.51338Z",
      fill: "url(#paint3_linear_2861_43292)",
      fillOpacity: "0.55"
    }), jsx("path", {
      d: "M24.606 1.29748C24.7467 1.2475 24.8809 1.2365 25.025 1.27506L20 20.0002L15.8899 12.8797L24.2557 1.55983C24.3432 1.43894 24.4654 1.34746 24.606 1.29748Z",
      fill: "url(#paint4_linear_2861_43292)",
      fillOpacity: "0.15"
    }), jsx("path", {
      d: "M14.5868 38.487C14.4901 38.3735 14.4301 38.2332 14.4148 38.0848L12.8749 24.1147L20 20.0001L14.975 38.7253C14.8309 38.6868 14.6836 38.6005 14.5868 38.487Z",
      fill: "url(#paint5_linear_2861_43292)",
      fillOpacity: "0.55"
    }), jsx("path", {
      d: "M15.3939 38.7029C15.2532 38.7529 15.119 38.7639 14.9749 38.7253L19.9999 20.0001L24.11 27.1206L15.7442 38.4405C15.6567 38.5614 15.5345 38.6529 15.3939 38.7029Z",
      fill: "url(#paint6_linear_2861_43292)",
      fillOpacity: "0.15"
    }), jsx("path", {
      d: "M38.4866 25.3982C38.373 25.495 38.2327 25.5551 38.0842 25.5705L24.1101 27.1206L20 20.0001L38.7253 25.0099C38.6866 25.1541 38.6002 25.3014 38.4866 25.3982Z",
      fill: "url(#paint7_linear_2861_43292)",
      fillOpacity: "0.55"
    }), jsx("path", {
      d: "M38.7032 24.5911C38.753 24.7317 38.7639 24.8658 38.7253 25.0099L20 20.0001L27.1251 15.8855L38.441 24.241C38.5619 24.3284 38.6533 24.4505 38.7032 24.5911Z",
      fill: "url(#paint8_linear_2861_43292)",
      fillOpacity: "0.15"
    }), jsx("path", {
      d: "M1.51342 14.6021C1.62701 14.5053 1.76731 14.4452 1.91575 14.4298L15.8899 12.8797L20 20.0002L1.27472 14.9904C1.3134 14.8463 1.39983 14.699 1.51342 14.6021Z",
      fill: "url(#paint9_linear_2861_43292)",
      fillOpacity: "0.55"
    }), jsx("path", {
      d: "M1.29688 15.4092C1.24699 15.2686 1.23609 15.1345 1.27476 14.9904L20 20.0002L12.8749 24.1148L1.55901 15.7593C1.43817 15.6718 1.34676 15.5498 1.29688 15.4092Z",
      fill: "url(#paint10_linear_2861_43292)",
      fillOpacity: "0.15"
    }), jsxs("defs", {
      children: [jsxs("linearGradient", {
        id: "paint0_linear_2861_43292",
        x1: "1.2639",
        y1: "15.0165",
        x2: "38.7817",
        y2: "25.0846",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "#4967FB"
        }), jsx("stop", {
          offset: "1",
          stopColor: "#C844DB"
        })]
      }), jsxs("linearGradient", {
        id: "paint1_linear_2861_43292",
        x1: "24.9437",
        y1: "1.63079",
        x2: "15.0971",
        y2: "38.6912",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.6"
        }), jsx("stop", {
          offset: "0.979167",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("radialGradient", {
        id: "paint2_radial_2861_43292",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(20.0324 20.0522) rotate(105.022) scale(23.3527 23.3229)",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.8"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint3_linear_2861_43292",
        x1: "30.0184",
        y1: "2.61097",
        x2: "20.0097",
        y2: "20.0058",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), jsxs("linearGradient", {
        id: "paint4_linear_2861_43292",
        x1: "20.0315",
        y1: "-0.060954",
        x2: "20.0151",
        y2: "20.0002",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), jsxs("linearGradient", {
        id: "paint5_linear_2861_43292",
        x1: "9.98156",
        y1: "37.3895",
        x2: "19.9903",
        y2: "19.9946",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), jsxs("linearGradient", {
        id: "paint6_linear_2861_43292",
        x1: "19.9683",
        y1: "40.0614",
        x2: "19.9847",
        y2: "20.0002",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), jsxs("linearGradient", {
        id: "paint7_linear_2861_43292",
        x1: "37.3852",
        y1: "30.0034",
        x2: "20.0056",
        y2: "19.9905",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), jsxs("linearGradient", {
        id: "paint8_linear_2861_43292",
        x1: "40.0653",
        y1: "20.0166",
        x2: "20",
        y2: "19.985",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), jsxs("linearGradient", {
        id: "paint9_linear_2861_43292",
        x1: "2.61469",
        y1: "9.99698",
        x2: "19.9944",
        y2: "20.0099",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), jsxs("linearGradient", {
        id: "paint10_linear_2861_43292",
        x1: "-0.0652607",
        y1: "19.9838",
        x2: "20",
        y2: "20.0154",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      })]
    })]
  });
};

export { Discover };
